/**
 * True when this document is running inside a frame — i.e. MSAL's hidden
 * silent-renewal iframe, which loads the SPA itself as the redirect URI.
 * Used by main.tsx to boot MSAL's relay (initialize + handleRedirectPromise)
 * without rendering the app: a full app boot inside that iframe fires nested
 * acquireTokenSilent calls, which MSAL rejects with block_iframe_reload and
 * which starves the parent's renewal into timed_out (observed 2026-09-30).
 *
 * A cross-origin parent makes window.top unreadable — the access throwing is
 * itself proof of framing, so report framed rather than crash.
 */
export function isFramed(): boolean {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}
